import axiosInstance from "@/axios/axiosInstance";
import { IApiError } from "@/interface/apiError.types";
import {
  IForgotPassword,
  IResetPasswordPayload,
  LoginCredentials,
  LoginResponse,
} from "@/interface/auth.types";
import { parseApiError } from "@/lib/error-parser";

// Define proper return types
interface AuthResponse<T = any> {
  success: boolean;
  data: T;
  message: string;
}

export const loginUser = async (
  data: LoginCredentials
): Promise<AuthResponse<LoginResponse>> => {
  try {
    const payload = {
      email: data.email,
      password: data.password,
      remember: true,
    };
    const response = await axiosInstance.post<AuthResponse<LoginResponse>>(
      `/login`,
      payload
    );
    return response.data;
  } catch (error) {
    parseApiError(error as IApiError);
    throw error;
  }
};

// =============================== Forget Password ===============================

export const forgetPassword = async (
  data: IForgotPassword
): Promise<AuthResponse<{ message: string }>> => {
  try {
    const payload = {
      email: data.email,
    };
    const response = await axiosInstance.put<AuthResponse<{ message: string }>>(
      `/forgot-password`,
      payload
    );
    return response.data;
  } catch (error) {
    parseApiError(error as IApiError);
    throw error;
  }
};

// =============================== Reset Password ===============================
export const resetPassword = async (
  data: IResetPasswordPayload
): Promise<AuthResponse<{ message: string }>> => {
  try {
    const payload = {
      password: data.password,
      confirm_password: data.confirm_password,
      token: data.token,
    };
    const response = await axiosInstance.put<AuthResponse<{ message: string }>>(
      `/reset-password`,
      payload
    );
    return response.data;
  } catch (error) {
    parseApiError(error as IApiError);
    throw error;
  }
};

// =============================== Logout ===============================
export const profileLogout = async (): Promise<
  AuthResponse<{ message: string }>
> => {
  try {
    const response = await axiosInstance.post<
      AuthResponse<{ message: string }>
    >("/logout");
    return response.data;
  } catch (error) {
    parseApiError(error as IApiError);
    throw error;
  }
};
